import { LineSkeletonStyled } from 'components/base/Skeletons';
import styled from 'styled-components';

export const StyledColumnSkeleton = styled(LineSkeletonStyled)`
  width: 3rem;
  height: ${props => `${props.size}%`} !important;
  transform: none !important;
`;

export const StyledColumnChartSkeleton = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  align-items: flex-end;
`;
